import { createAxiosDateTransformer } from 'axios-date-transformer'
import { useUserStore } from '@/stores/userStore'
import { useNotificationsStore } from '@/stores/notificationStore';

const instance = createAxiosDateTransformer({
  baseURL: import.meta.env.VITE_API_ENDPOINT,
  withCredentials: true
});

// Add a request interceptor for impersonation
instance.interceptors.request.use(function (config) {
  const impersonatedUserId = sessionStorage.getItem('MyNemo.impersonatedUserId');
  if(impersonatedUserId) {
    config.headers['x-ImpersonatedUser'] =  impersonatedUserId;
  }
  return config;
});

// Add a response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const statusCode = error?.response?.status;

    if(statusCode === 401) {
      const userStore = useUserStore();
      userStore.logout();
    } else if(statusCode === 403) {
      const notificationsStore = useNotificationsStore();
      notificationsStore.notifyError('Vous n\'avez pas les droits pour effectuer cette action.');
      import('@/router').then(({ default: router }) => {
        router.push({ name: 'home' });
      });
    } else if(error?.response?.data?.message) {
      return Promise.reject(Error(error?.response?.data?.message));
    } else if (error?.response?.data?.errors?.$) {
      return Promise.reject(Error(`[${statusCode}] ${error?.response?.data?.errors?.$.join('<br>')}`));
    } else if (error?.response?.data?.title) {
      return Promise.reject(Error(`[${statusCode}] ${error?.response?.data?.title}`));
    } else if (statusCode === 404 && error.response?.data != null) {
      return Promise.reject(Error(`${error.response?.data}`));
    }

    return Promise.reject(error);
  }
);

export default instance
